/**
 * Whether a detection record passes the applied filters + legend grades.
 * Shared by the header stats and the empty-state check so they always agree.
 */
import type { PlumeGrade } from "../data/types";
import type { DetectionRecord } from "../store/dataStore";
import type { FilterValues } from "../store/filtersStore";

export function recordMatches(
  rec: DetectionRecord,
  applied: FilterValues,
  grades: PlumeGrade[],
): boolean {
  if (grades.length && !grades.includes(rec.grade)) return false;
  if (applied.from && rec.date < applied.from) return false;
  if (applied.to && rec.date > applied.to) return false;
  if (applied.satellites.length && !applied.satellites.includes(rec.satellite)) return false;
  if (applied.minRate > 0 && (rec.emissionRate === null || rec.emissionRate < applied.minRate)) {
    return false;
  }
  return true;
}
